<template>
  <div>
    <div class="container-wrapper">
      <!-- <Header :acctName="acctName"></Header> -->
      <!--<div>{{acctName}}</div>-->
      <!-- <keep-alive> -->
      <router-view></router-view>
      <!-- </keep-alive> -->
    </div>
    <div class="copy-right">网络经营许可证 <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备20014012号-1</a> © Copyright 2020 上海绿地建筑材料集团有限公司 版权所有</div>
  </div>
</template>

<script>
import {
  InterfaceService
} from '@/services/api'
import Header from '@/components/base/Header'

export default {
  components: {
    Header
  },
  data: function () {
    return {
    }
  },
  watch: {
  },
  computed: {
  },
  created() {

  },
  methods: {
    initCategoryList() {
      let categoryList = sessionStorage.getItem('categoryList')
      if (categoryList) {
        this.$store.commit('changeCategoryList', JSON.parse(categoryList))
      } else {
        InterfaceService.getCategoryList(res => {
          this.$store.commit('changeCategoryList', res['children'])
          this.$setRootScope('categoryList', JSON.stringify(res['children']))
        });
      }
    }
  },
  mounted() {

  },
  destroyed: function () {


  }
}
</script>

<style>
@import "../assets/style.css";
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue